import { createFileRoute } from "@tanstack/react-router";
import { z } from "zod";

export const Route = createFileRoute("/admindashboard/_layout/kpi")({
  validateSearch: z.object({
    ids: z.array(z.string().uuid()).optional(),
    entityType: z.enum(["staff", "user"]).default("staff"),
    startDate: z
      .string()
      .date()
      .default(() => new Date(new Date().getFullYear(), 0, 1).toISOString().slice(0, 10)),
    endDate: z
      .string()
      .date()
      .default(() => new Date().toISOString().slice(0, 10)),
    aggregation: z.enum(["events", "revenue", "payout"]).default("events"),
    page: z.number().int().positive().catch(1),
    selectAll: z.boolean().optional().default(false),
  }),
});
